export default "__VITE_ASSET__CV6VrBg0__"